import { useEffect, useRef, useState } from 'react'

export function useAnimateSize<T = HTMLDivElement>() {
  const [width, setWidth] = useState(100)
  const [height, setHeight] = useState(100)

  const observeRef = useRef<T>(null)

  useEffect(() => {
    // コンストラクタとコールバック
    const observer = new ResizeObserver((entries) => {
      setWidth(entries[0].contentRect.width)
      setHeight(entries[0].contentRect.height)
    })

    const elm = observeRef.current as unknown as Element
    elm && observer.observe(elm as unknown as Element)
    if (elm) {
      setWidth(elm.clientWidth as number)
      setHeight(elm.clientHeight as number)
    }
    // クリーンアップ関数で監視を解く
    return () => {
      observer.disconnect()
    }
  }, [])

  return {
    height,
    observeRef,
    width,
  }
}

export const useDynamicRect = (
  deps: any[] = [],
) => {
  const [rect, setRect] = useState<DOMRect>({
    width: 100,
    height: 100,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    x: 0,
    y: 0,
    toJSON: () => ({
      width: 100,
      height: 100,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    }),

  })

  const observeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // コンストラクタとコールバック
    const observer = new ResizeObserver((entries) => {
      const rect = observeRef.current!.getBoundingClientRect()
      setRect(rect)
    })
    observeRef.current && observer.observe(observeRef.current)
    if (observeRef.current) {
      console.log('observeRef.current.getBoundingClientRect():', observeRef.current.getBoundingClientRect());
      const rect = observeRef.current.getBoundingClientRect()
      setRect(rect)
    }
    // クリーンアップ関数で監視を解く
    return () => {
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps])

  return {
    rect,
    observeRef,
  }
}
